export default "__VITE_ASSET__DSqDS$OT__"